export const REGION = 'eu-west-1';
export const USER_POOL_ID = 'eu-west-1_hH7ToA8F3';
export const APP_CLIENT_ID = '22o4a3h3gf6jabs5st0h7qtbbn';
export const IDENTITY_POOL_ID = 'eu-west-1:815306f3-980b-4765-8eb9-a8f4b30b5725';
export const COGNITO_DOMAIN = 'ee-portal-auth-gamma.auth.eu-west-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'gamma';
export const APPEAL_ENABLED = 'true';